import moment from 'moment'
import React, { useEffect } from 'react'
import Chart from 'react-apexcharts'

export const AreaChart = ({ data }) => {
    const [series, setSeries] = React.useState([
        {
            name: 'series1',
            data: [0],
        },
    ])
    const [options, setOption] = React.useState({
        chart: {
            type: 'area',
            height: 160,
            toolbar: { show: false },
            sparkline: { enabled: false },
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            curve: 'smooth',
            width: 2,
        },
        markers: {
            size: 4,
            colors: ['#fff'],
            strokeColors: '#007bff',
            strokeWidth: 2,
            hover: { size: 6 },
        },
        grid: {
            show: false,
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
            },
        },
        xaxis: {
            categories: [],
            labels: {
                show: false, // hide labels
            },
            axisBorder: {
                show: true, // show bottom line
            },
            axisTicks: {
                show: true, // keep ticks if needed
            },
        },
        yaxis: {
            show: false,
            labels: { show: false },
        },
    })
    useEffect(() => {
        const result = {}
        const datetime = []
        if (data) {
            if (typeof data === typeof []) {
                data.forEach((a) => {
                    a.measurements.forEach((d) => {
                        if (!result[d.name]) {
                            result[d.name] = []
                        }
                        result[d.name].push(d.value)
                    })
                    datetime.push(
                        moment.unix(a.mea_timestamp).format('DD/MM/YYYY')
                    )
                })
            }

            setOption((p) => ({
                ...p,
                xaxis: {
                    ...p.xaxis,
                    categories: datetime,
                },
            }))

            setSeries(
                Object.entries(result).map(([key, value]) => {
                    return {
                        name: key,
                        data: value,
                    }
                })
            )
        }
    }, [data])

    return <Chart type="area" series={series} options={options} />
}
